import { useEffect, useState } from 'react';

const KEY = 'playerbase.auth.email';

// Persists the email field across sign-in, sign-up, and forgot-password so a
// user who landed on the wrong form does not have to retype it after switching.
// Scoped to sessionStorage so it clears when the tab closes.
export function useSharedEmail(): [string, (value: string) => void] {
  const [email, setEmail] = useState<string>(() => {
    try {
      return sessionStorage.getItem(KEY) ?? '';
    } catch {
      return '';
    }
  });

  useEffect(() => {
    try {
      if (email === '') {
        sessionStorage.removeItem(KEY);
      } else {
        sessionStorage.setItem(KEY, email);
      }
    } catch {
      // sessionStorage may be unavailable (Safari private mode etc.)
    }
  }, [email]);

  return [email, setEmail];
}
